import { PAYMENT_METHODS } from './interfaces';

interface AvailablePaymentMethod {
  label: string;
  value: PAYMENT_METHODS;
}

export const AVAILABLE_PAYMENT_METHODS: AvailablePaymentMethod[] = [
  {
    label: 'External Bank Transfer (Access Bank)',
    value: PAYMENT_METHODS.EXTERNAL_BANK_TRANSFER_ACCESS
  },
  {
    label: 'External Bank Transfer (Providus Bank)',
    value: PAYMENT_METHODS.EXTERNAL_BANK_TRANSFER_PROVIDUS
  }
];
